import { createAction } from '@ngrx/store';

export const loadSelectedPrices = createAction('Load selected prices');
